import React from 'react';
import PropTypes from 'prop-types';
import { Field } from 'formik';
import clsx from 'clsx';

import Label from '@dashboard/components/Form/components/Label';
import LabelDescription from '@dashboard/components/Form/components/LabelDescription';

const propTypes = {
  values: PropTypes.object.isRequired,
  name: PropTypes.string.isRequired,
  required: PropTypes.bool,
};

const defaultProps = {
  required: false,
};

const Checkbox = ({ name, className, ...props }) => (
  <Field
    type="checkbox"
    name={name}
    className={clsx(
      className,
      'h-[18px] w-[18px] text-chocolate-600 border-gray-300 focus:ring-gray-300 focus:ring-2 rounded mt-[2px]',
    )}
    {...props}
  />
);

const Wrapper = ({ children }) => <div className="flex gap-x-2 w-full">{children}</div>;

const CheckboxLabel = props => <Label isInline {...props} />;
const CheckboxLabelDescription = props => <LabelDescription {...props} />;

Checkbox.Wrapper = Wrapper;
Checkbox.Label = CheckboxLabel;
Checkbox.LabelDescription = CheckboxLabelDescription;

Checkbox.propTypes = propTypes;
Checkbox.defaultProps = defaultProps;

export default Checkbox;
